const yup = require("yup");

const generalSettings = yup.object().shape({
  mileageReimbursement: yup.object().shape({
    type: yup.string().required("Type is required"),
    rate: yup
      .number()
      .nullable()
      .min(0.01, "Rate must be greater than 0")
      .required("Rate is required")
      .typeError("Rate must be a number"),
  }),
});

export default generalSettings;
